const env = {
  currentBu: process.env.REACT_APP_BU ?? "hk",
  isStorePolicyDate: process.env.REACT_APP_STORE_POLICY_DATA === "true",
  tfCoachPromoCode: process.env.REACT_APP_THOUGHTFULL_COACH_PROMOCODE ?? "",
  tfCoachLinkWithPromoCode: process.env.REACT_APP_THOUGHTFULL_COACH_PROMOCODE_URL ?? "",
  displaySaveResultLinkButton: process.env.REACT_APP_DISPLAY_SAVE_RESULT_LINK === 'true'
};

export default env;
